export default "<button (click)=\"selectAll()\" class=\"full-width\" color=\"primary\" mat-button>Выбрать все</button>\n";